import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConfigureComponent } from './pages/configure/configure.component';
import { FileComponent } from './pages/form/form-components/file/file.component';
import { MessageComponent } from './pages/form/form-components/message/message.component';
import { FormComponent } from './pages/form/form.component';
import { LandingComponent } from './pages/landing/landing.component';
import { WelcomeAuthenticateComponent } from './pages/welcome-authenticate/welcome-authenticate.component';
import { WelcomeConfigureComponent } from './pages/welcome-configure/welcome-configure.component';
import { WelcomeWizardComponent } from './pages/welcome-wizard/welcome-wizard.component';
import { DragDropDirective } from './shared/directives/dragDrop.directive';

@NgModule({
	declarations: [
		AppComponent,
		ConfigureComponent,
		FileComponent,
		FormComponent,
		LandingComponent,
		MessageComponent,
		WelcomeAuthenticateComponent,
		WelcomeConfigureComponent,
		WelcomeWizardComponent,
		DragDropDirective,
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule,
		NgSelectModule
	],
	providers: [
		{ provide: LocationStrategy, useClass: PathLocationStrategy }
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
